import React, { useContext, useState } from 'react';
import { message } from 'antd';
import useAsyncEffect from 'src/hooks/useAsyncEffect';
import { useAppStateContext } from 'src/stateProviders/useAppStateContext';
import { ProductAlertsContext } from '../ProductAlertsProvider';
import { getUsersProductSegment, UsersProductSegmentResponse } from '../api/productAlerts.api';
import { FiltersContext } from './FiltersContext';
import FiltersForm, { FiltersFormValues } from './FiltersForm';
import styles from './ProductSegmentFilters.module.less';

export const ProductSegmentFilters: React.FC = () => {
  const { user = null } = useAppStateContext();
  const { changeFilter } = useContext(ProductAlertsContext);
  const { formKey, collapsed, setFiltersCount } = useContext(FiltersContext);
  const [segmentUsers, setSegmentUsers] = useState<string[]>([]);

  const handleChange = (changes: Partial<FiltersFormValues>) => {
    setFiltersCount(Object.keys(changes).length);
  };

  useAsyncEffect(async () => {
    try {
      const response: UsersProductSegmentResponse = await getUsersProductSegment();
      setSegmentUsers(response.segmentUser.segmentUserList);
    } catch (e) {
      message.error('Users haven`t loaded!');
    }
  }, []);

  return (
    <div className={styles.container} hidden={collapsed}>
      <FiltersForm
        key={formKey}
        user={user}
        segmentUsers={segmentUsers}
        onChange={handleChange}
        changeFilter={changeFilter}
      />
    </div>
  );
};
